import { useState } from "react";
import { Statuses } from "../../Shared/statuses";
import { useEffect } from "react";

export default function RecentRegNums({ regNums, school }) {

    return (
        <div className="col-8 w-100-mob w-100-l">
            <div className="overflow-auto card recent-sales" style={{ minHeight: '370px' }}>

                <div className="card-body">
                    <h5 className="card-title text-xl use-font">Последно регистрирани заявления <span className="use-font"> | {school}</span></h5>

                    <table className="table table-borderless datatable">
                        <thead>
                            <tr>
                                <th scope="col" className='text-lg'>Рег. №</th>
                                <th scope="col" className='text-lg'>Дете</th>
                                <th scope="col" className='text-lg'>Статус</th>
                            </tr>
                        </thead>
                        <tbody>
                            {regNums.map((x, i) =>
                                <tr key={i} className={`${(i == 0) ? 'fadeRight' : ''}`}>
                                    <th scope="row" className='text-lg fw-normal'>{x.regId}</th>
                                    <td className='text-lg '>{x.childName}</td>
                                    <td className='text-lg'>
                                        <span
                                            className={`badge ${x.status == 4 ? 'bg-success' : x.status == 0 ? 'bg-warning' : x.status == 1 ? 'bg-primary' : (x.status == 2 || x.status == 9) ? 'bg-danger' : 'bg-primary'}`}
                                            >
                                        {Statuses[`${x.status}`]}
                                    </span>
                                </td>
                                </tr>
                            )}

                    </tbody>
                </table>

            </div>

        </div>
        </div >
    )
}